<script setup lang="ts"></script>

<template>
  <BaseContainer class="py-10">
    <div class="flex flex-col md:grid grid-cols-2 py-6 space-y-6 md:space-y-0">
      <div
        class="border-b md:border-b-0 md:border-r border-border-divider flex flex-col items-center justify-center space-y-4 px-4 pb-6 md:pb-0"
      >
        <div class="font-bold text-xl">{{ $t('footer.infoPayment') }}</div>
        <div
          class="flex items-center gap-x-7 h-[45px] *:object-contain *:h-full"
        >
          <NuxtImg
            alt="visa"
            src="/images/secure-checkout-visa.webp"
            loading="lazy"
          />
          <NuxtImg
            alt="mastercard"
            src="/images/secure-checkout-mastercard.webp"
            loading="lazy"
          />
          <NuxtImg
            alt="promptpay"
            src="/images/secure-checkout-promptpay.webp"
            loading="lazy"
          />
        </div>
      </div>
      <div class="flex flex-col items-center justify-center space-y-4 px-4">
        <div>
          <div class="font-bold text-xl">{{ $t('footer.infoWarranty') }}</div>
        </div>
        <div class="text-center px-6 text-typo-secondary">
          {{ $t('footer.infoDesc') }}
        </div>
      </div>
    </div>
  </BaseContainer>
</template>
